export default "__VITE_ASSET__C6VIhddY__"